import { Autocomplete } from "@material-ui/lab";
import {
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { useState } from "react";
let i = 0;
const CrfCoacheeNameInput = (props) => {
  const { employeesListForOrg, row, getEmployeeDetails } = props;

  const [empValue, setEmpValue] = useState("");

  const [dialogOpen, setDialogOpen] = useState({
    isOpen: false,
    selectedValue: {},
  });

  const handleUpdateTable = () => {
    if (dialogOpen.selectedValue) {
      console.log(dialogOpen.selectedValue, "open dialog ");
      setEmpValue(dialogOpen.selectedValue);
      getEmployeeDetails(dialogOpen.selectedValue.id);
      setDialogOpen({ isOpen: false, selectedValue: {} });
    }
  };

  const handleCloseWarning = () => {
    setDialogOpen(false);
    setDialogOpen({ isOpen: false, selectedValue: {} });
  };

  const handleCoacheeNameChange = (event, newValue) => {
    if (newValue === null) {
      newValue = "";
    } else if (newValue !== null) {
      setDialogOpen({ isOpen: true, selectedValue: newValue });
    }
  };
  const coacheeNameValue =
    empValue ||
    Object.assign(
      {},
      ...employeesListForOrg.filter((v) => `${v.id}` === row.answer)
    );

  console.log(empValue, coacheeNameValue, "emppValue");

  return (
    <>
      {" "}
      <Autocomplete
        id="crf-coachee-name"
        options={employeesListForOrg}
        getOptionLabel={(option) => option.full_name}
        value={coacheeNameValue}
        onChange={handleCoacheeNameChange}
        defaultValue={coacheeNameValue}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              style: { fontSize: "16px" },
            }}
            placeholder="Employee name"
            variant="outlined"
          />
        )}
        sx={{ width: "500px" }}
      />
      <Dialog open={dialogOpen.isOpen} onClose={handleCloseWarning}>
        <DialogContent dividers>
          <Typography>
            Are you sure you want to update the details for the coachee?
            Updating will override the details submitted in CRF and replace it
            with data from employee record
          </Typography>
          <Grid container direction="row" alignItems="flex-start">
            <Grid item xs={8}></Grid>
            <Grid item xs={2}>
              <Button
                disableElevation
                variant="contained"
                style={{
                  background: "#EF7000",
                  color: "white",
                  textTransform: "initial",
                }}
                onClick={handleUpdateTable}
              >
                Update
              </Button>
            </Grid>
            <Grid item xs={2}>
              <Button
                disableElevation
                variant="contained"
                onClick={handleCloseWarning}
                style={{ textTransform: "initial" }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default CrfCoacheeNameInput;
